export const translations = {
  nav: {
    es: {
      features: "Funciones",
      disciplines: "Disciplinas",
      screenshots: "App",
      pricing: "Precios",
      faq: "FAQ",
      download: "Descargar",
    },
    en: {
      features: "Features",
      disciplines: "Disciplines",
      screenshots: "App",
      pricing: "Pricing",
      faq: "FAQ",
      download: "Download",
    },
  },
  hero: {
    es: {
      tagline: "TIMER DE COMBATE",
      title: "MIXED MARTIAL ARTS TIMER",
      subtitle:
        "Timer preciso y confiable para MMA, boxeo, kickboxing, muay thai, BJJ y HIIT. Configura rounds, intervalos y sesiones completas. Offline-first.",
      appStore: "App Store",
      downloadOn: "Descargar en",
    },
    en: {
      tagline: "COMBAT TIMER",
      title: "MIXED MARTIAL ARTS TIMER",
      subtitle:
        "Precise and reliable timer for MMA, boxing, kickboxing, muay thai, BJJ and HIIT. Configure rounds, intervals and full sessions. Offline-first.",
      appStore: "App Store",
      downloadOn: "Download on",
    },
  },
  features: {
    es: {
      caption: "FUNCIONES PRINCIPALES",
      title: "TODO LO QUE NECESITAS PARA ENTRENAR",
      items: [
        {
          icon: "Zap",
          title: "QUICK START",
          desc: "Inicia una sesion en segundos. Configura rounds, descanso y cantidad. Sin complicaciones.",
        },
        {
          icon: "LayoutList",
          title: "SESSION BUILDER",
          desc: "Crea sesiones lineales con bloques de warmup, trabajo, descanso y cooldown personalizados.",
        },
        {
          icon: "BookmarkCheck",
          title: "PRESETS ILIMITADOS",
          desc: "Guarda, edita, duplica y marca favoritos. Biblioteca base incluida para cada disciplina.",
        },
        {
          icon: "Timer",
          title: "TIMER PRECISO",
          desc: "Motor basado en timestamps reales. Funciona en background y con pantalla bloqueada.",
        },
        {
          icon: "Bell",
          title: "ALERTAS MULTI-MODO",
          desc: "Sonido, vibracion y alertas visuales configurables. Pre-alertas antes de cada transicion.",
        },
        {
          icon: "BarChart3",
          title: "HISTORIAL Y METRICAS",
          desc: "Registro local de sesiones completadas. Metricas agregadas por semana y mes.",
        },
        {
          icon: "Smartphone",
          title: "OFFLINE-FIRST",
          desc: "Funcionalidad completa sin conexion. Tus datos se quedan en tu dispositivo.",
        },
        {
          icon: "FileText",
          title: "EXPORTAR A PDF",
          desc: "Genera reportes PDF de tus metricas. Comparte o guarda tu progreso. Feature premium.",
        },
      ],
    },
    en: {
      caption: "CORE FEATURES",
      title: "EVERYTHING YOU NEED TO TRAIN",
      items: [
        {
          icon: "Zap",
          title: "QUICK START",
          desc: "Start a session in seconds. Set rounds, rest and count. No hassle.",
        },
        {
          icon: "LayoutList",
          title: "SESSION BUILDER",
          desc: "Create linear sessions with customizable warmup, work, rest and cooldown blocks.",
        },
        {
          icon: "BookmarkCheck",
          title: "UNLIMITED PRESETS",
          desc: "Save, edit, duplicate and favorite. Base library included for each discipline.",
        },
        {
          icon: "Timer",
          title: "PRECISE TIMER",
          desc: "Engine based on real timestamps. Works in background and with screen locked.",
        },
        {
          icon: "Bell",
          title: "MULTI-MODE ALERTS",
          desc: "Configurable sound, vibration and visual alerts. Pre-alerts before each transition.",
        },
        {
          icon: "BarChart3",
          title: "HISTORY & METRICS",
          desc: "Local log of completed sessions. Aggregated metrics by week and month.",
        },
        {
          icon: "Smartphone",
          title: "OFFLINE-FIRST",
          desc: "Full functionality without connection. Your data stays on your device.",
        },
        {
          icon: "FileText",
          title: "PDF EXPORT",
          desc: "Generate PDF reports of your metrics. Share or save your progress. Premium feature.",
        },
      ],
    },
  },
  disciplines: {
    es: {
      caption: "DISCIPLINAS",
      title: "PARA CADA ESTILO DE COMBATE",
      items: [
        { name: "MMA", desc: "Rounds de 5 min, descanso 1 min" },
        { name: "BOXEO", desc: "Rounds de 3 min, descanso 1 min" },
        { name: "KICKBOXING", desc: "Rounds de 3 min, descanso 1 min" },
        { name: "MUAY THAI", desc: "Rounds de 3 min, descanso 2 min" },
        { name: "BJJ", desc: "Rounds de 5-10 min, transiciones" },
        { name: "HIIT", desc: "Intervalos configurables trabajo/descanso" },
      ],
    },
    en: {
      caption: "DISCIPLINES",
      title: "FOR EVERY COMBAT STYLE",
      items: [
        { name: "MMA", desc: "5 min rounds, 1 min rest" },
        { name: "BOXING", desc: "3 min rounds, 1 min rest" },
        { name: "KICKBOXING", desc: "3 min rounds, 1 min rest" },
        { name: "MUAY THAI", desc: "3 min rounds, 2 min rest" },
        { name: "BJJ", desc: "5-10 min rounds, transitions" },
        { name: "HIIT", desc: "Configurable work/rest intervals" },
      ],
    },
  },
  screenshots: {
    es: {
      caption: "LA APP",
      title: "DISENADA PARA EL RING",
      subtitle: "Interfaz clara, botones grandes y feedback visual inmediato. Pensada para manos con guantes.",
    },
    en: {
      caption: "THE APP",
      title: "DESIGNED FOR THE RING",
      subtitle: "Clear interface, large buttons and instant visual feedback. Built for gloved hands.",
    },
  },
  pricing: {
    es: {
      caption: "PRECIOS",
      title: "SIMPLE Y DIRECTO",
      free: {
        name: "GRATIS",
        price: "$0",
        period: "para siempre",
        features: [
          "Quick Start ilimitado",
          "Session Builder completo",
          "Presets ilimitados",
          "Biblioteca base de presets",
          "Historial local",
          "Metricas en app",
          "Alertas audio/vibracion",
          "Soporte background",
        ],
        cta: "DESCARGAR GRATIS",
      },
      premium: {
        name: "PREMIUM",
        price: "Unico pago",
        period: "para siempre",
        features: [
          "Todo lo del plan gratis",
          "Exportar metricas a PDF",
          "Reportes semanales",
          "Reportes mensuales",
          "Historial completo en PDF",
          "Compartir reportes",
          "Guardar reportes",
          "Soporte prioritario",
        ],
        cta: "OBTENER PREMIUM",
      },
    },
    en: {
      caption: "PRICING",
      title: "SIMPLE AND DIRECT",
      free: {
        name: "FREE",
        price: "$0",
        period: "forever",
        features: [
          "Unlimited Quick Start",
          "Full Session Builder",
          "Unlimited presets",
          "Base preset library",
          "Local history",
          "In-app metrics",
          "Audio/vibration alerts",
          "Background support",
        ],
        cta: "DOWNLOAD FREE",
      },
      premium: {
        name: "PREMIUM",
        price: "One-time",
        period: "forever",
        features: [
          "Everything in Free",
          "Export metrics to PDF",
          "Weekly reports",
          "Monthly reports",
          "Full history in PDF",
          "Share reports",
          "Save reports",
          "Priority support",
        ],
        cta: "GET PREMIUM",
      },
    },
  },
  faq: {
    es: {
      caption: "PREGUNTAS FRECUENTES",
      title: "FAQ",
      items: [
        {
          q: "Necesito conexion a internet para usar la app?",
          a: "No. La app es 100% offline-first. Todas las funciones principales funcionan sin conexion. Tus datos se almacenan localmente en tu dispositivo.",
        },
        {
          q: "Funciona el timer cuando la app esta en background?",
          a: "Si. El motor de sesiones esta basado en timestamps reales, no en el ciclo de render de la UI. Al volver a la app, el tiempo se recalcula automaticamente con precision.",
        },
        {
          q: "Puedo crear sesiones personalizadas con diferentes bloques?",
          a: "Si. El Session Builder te permite crear sesiones lineales con bloques de warmup, trabajo, descanso, cooldown y bloques personalizados con duracion y nombre configurables.",
        },
        {
          q: "Que disciplinas soporta?",
          a: "MMA, boxeo, kickboxing, muay thai, BJJ y entrenamiento funcional por intervalos (HIIT). Incluye presets base para cada disciplina.",
        },
        {
          q: "Que incluye el plan premium?",
          a: "El plan premium agrega exportacion de metricas a PDF con reportes semanales, mensuales y de historial completo. Puedes compartir y guardar los reportes.",
        },
        {
          q: "Esta disponible para iOS y Android?",
          a: "Si. La app se lanza simultaneamente en ambas plataformas con funcionalidad identica.",
        },
      ],
    },
    en: {
      caption: "FREQUENTLY ASKED QUESTIONS",
      title: "FAQ",
      items: [
        {
          q: "Do I need internet to use the app?",
          a: "No. The app is 100% offline-first. All core features work without connection. Your data is stored locally on your device.",
        },
        {
          q: "Does the timer work when the app is in background?",
          a: "Yes. The session engine is based on real timestamps, not the UI render loop. When returning to the app, time is recalculated automatically with precision.",
        },
        {
          q: "Can I create custom sessions with different blocks?",
          a: "Yes. The Session Builder lets you create linear sessions with warmup, work, rest, cooldown and custom blocks with configurable duration and name.",
        },
        {
          q: "What disciplines does it support?",
          a: "MMA, boxing, kickboxing, muay thai, BJJ and functional interval training (HIIT). Base presets included for each discipline.",
        },
        {
          q: "What does the premium plan include?",
          a: "The premium plan adds PDF metrics export with weekly, monthly and full history reports. You can share and save reports.",
        },
        {
          q: "Is it available for iOS and Android?",
          a: "Yes. The app launches simultaneously on both platforms with identical functionality.",
        },
      ],
    },
  },
  footer: {
    es: {
      tagline: "Timer de precision para deportes de combate y entrenamiento funcional.",
      sections: "Secciones",
      legal: "Legal",
      privacy: "Privacidad",
      terms: "Terminos",
      rights: "Todos los derechos reservados.",
    },
    en: {
      tagline: "Precision timer for combat sports and functional training.",
      sections: "Sections",
      legal: "Legal",
      privacy: "Privacy",
      terms: "Terms",
      rights: "All rights reserved.",
    },
  },
  privacy: {
    es: {
      backHome: "Volver al inicio",
      title: "Politica de Privacidad",
      lastUpdated: "Ultima actualizacion: 19 de marzo de 2026",
      intro:
        "En MMA Timer, respetamos tu privacidad. Esta politica describe como recopilamos, usamos y protegemos tu informacion cuando utilizas nuestra aplicacion movil.",
      dataCollection: {
        title: "Informacion que Recopilamos",
        desc: "MMA Timer es una aplicacion offline-first. Recopilamos la minima informacion necesaria para el funcionamiento de la app:",
        items: [
          "Datos de sesiones de entrenamiento (rounds, tiempos, configuraciones) — almacenados localmente en tu dispositivo",
          "Presets y configuraciones personalizadas — almacenados localmente en tu dispositivo",
          "Historial de entrenamientos y metricas — almacenados localmente en tu dispositivo",
          "Datos anonimos de uso y rendimiento de la app (crashes, errores) para mejorar la calidad del servicio",
        ],
      },
      dataUsage: {
        title: "Como Usamos tu Informacion",
        desc: "Utilizamos la informacion recopilada para los siguientes fines:",
        items: [
          "Proporcionar y mantener las funciones de la aplicacion",
          "Guardar tus sesiones, presets y preferencias localmente",
          "Generar reportes de metricas y estadisticas (feature premium)",
          "Mejorar la estabilidad y rendimiento de la aplicacion",
          "Responder a solicitudes de soporte tecnico",
        ],
      },
      dataStorage: {
        title: "Almacenamiento de Datos",
        desc: "Todos tus datos de entrenamiento, presets y configuraciones se almacenan exclusivamente en tu dispositivo. No transferimos ni almacenamos tus datos personales en servidores externos. Si desinstales la aplicacion, todos los datos locales se eliminan permanentemente.",
      },
      userRights: {
        title: "Tus Derechos",
        desc: "Tienes los siguientes derechos sobre tus datos:",
        items: [
          "Acceder a todos tus datos almacenados en la aplicacion",
          "Exportar tus datos en formato PDF (feature premium)",
          "Eliminar todos tus datos desinstalando la aplicacion",
          "Solicitar la eliminacion de cualquier dato anonimo recopilado contactandonos directamente",
        ],
      },
      contact: {
        title: "Contacto",
        desc: "Si tienes preguntas sobre esta politica de privacidad o sobre el manejo de tus datos, contactanos:",
      },
    },
    en: {
      backHome: "Back to home",
      title: "Privacy Policy",
      lastUpdated: "Last updated: March 19, 2026",
      intro:
        "At MMA Timer, we respect your privacy. This policy describes how we collect, use and protect your information when you use our mobile application.",
      dataCollection: {
        title: "Information We Collect",
        desc: "MMA Timer is an offline-first application. We collect the minimum information necessary for the app to function:",
        items: [
          "Training session data (rounds, times, configurations) — stored locally on your device",
          "Custom presets and configurations — stored locally on your device",
          "Training history and metrics — stored locally on your device",
          "Anonymous app usage and performance data (crashes, errors) to improve service quality",
        ],
      },
      dataUsage: {
        title: "How We Use Your Information",
        desc: "We use the collected information for the following purposes:",
        items: [
          "Provide and maintain application features",
          "Save your sessions, presets and preferences locally",
          "Generate metrics and statistics reports (premium feature)",
          "Improve application stability and performance",
          "Respond to technical support requests",
        ],
      },
      dataStorage: {
        title: "Data Storage",
        desc: "All your training data, presets and configurations are stored exclusively on your device. We do not transfer or store your personal data on external servers. If you uninstall the application, all local data is permanently deleted.",
      },
      userRights: {
        title: "Your Rights",
        desc: "You have the following rights over your data:",
        items: [
          "Access all your data stored in the application",
          "Export your data in PDF format (premium feature)",
          "Delete all your data by uninstalling the application",
          "Request deletion of any anonymous data collected by contacting us directly",
        ],
      },
      contact: {
        title: "Contact",
        desc: "If you have questions about this privacy policy or about the handling of your data, contact us:",
      },
    },
  },
  terms: {
    es: {
      backHome: "Volver al inicio",
      title: "Terminos y Condiciones",
      lastUpdated: "Ultima actualizacion: 19 de marzo de 2026",
      intro:
        "Estos terminos y condiciones regulan el uso de la aplicacion movil MMA Timer. Al descargar, instalar o usar la aplicacion, aceptas estos terminos en su totalidad.",
      acceptance: {
        title: "Aceptacion de Terminos",
        desc: "Al acceder y utilizar MMA Timer, confirmas que has leido, entendido y aceptado estos terminos. Si no estas de acuerdo con alguna parte de estos terminos, no debes utilizar la aplicacion.",
      },
      license: {
        title: "Licencia de Uso",
        desc: "Te otorgamos una licencia limitada, no exclusiva, no transferible y revocable para usar MMA Timer en tu dispositivo movil personal. Esta licencia no te otorga derechos de propiedad sobre la aplicacion ni su contenido.",
      },
      restrictions: {
        title: "Restricciones de Uso",
        desc: "Al usar MMA Timer, aceptas no:",
        items: [
          "Modificar, descompilar, desensamblar o aplicar ingenieria inversa a la aplicacion",
          "Distribuir, sublicenciar o transferir la aplicacion a terceros",
          "Usar la aplicacion para fines ilegales o no autorizados",
          "Intentar acceder a sistemas o redes no autorizadas a traves de la aplicacion",
          "Eliminar o alterar avisos de derechos de autor o marcas comerciales",
        ],
      },
      purchases: {
        title: "Compras y Suscripciones",
        desc: "MMA Timer ofrece funciones premium disponibles mediante un pago unico dentro de la aplicacion. Las compras se procesan a traves de la tienda de aplicaciones correspondiente (Google Play Store o Apple App Store) y estan sujetas a sus politicas de reembolso. El plan gratuito incluye todas las funciones principales de la aplicacion sin limitaciones de tiempo.",
      },
      liability: {
        title: "Limitacion de Responsabilidad",
        desc: "MMA Timer se proporciona \"tal cual\" y \"segun disponibilidad\". No garantizamos que la aplicacion sea ininterrumpida, libre de errores o que cumpla con tus requisitos especificos. No somos responsables de lesiones, danos o perdidas que puedan resultar del uso de la aplicacion durante entrenamientos o actividades fisicas. Siempre consulta a un profesional antes de iniciar cualquier programa de entrenamiento.",
      },
      changes: {
        title: "Cambios en los Terminos",
        desc: "Nos reservamos el derecho de modificar estos terminos en cualquier momento. Los cambios se publicaran en esta pagina y, si son significativos, te notificaremos a traves de la aplicacion. El uso continuado de MMA Timer despues de la publicacion de los cambios constituye tu aceptacion de los nuevos terminos.",
      },
      contact: {
        title: "Contacto",
        desc: "Si tienes preguntas sobre estos terminos y condiciones, contactanos:",
      },
    },
    en: {
      backHome: "Back to home",
      title: "Terms and Conditions",
      lastUpdated: "Last updated: March 19, 2026",
      intro:
        "These terms and conditions govern the use of the MMA Timer mobile application. By downloading, installing or using the application, you accept these terms in their entirety.",
      acceptance: {
        title: "Acceptance of Terms",
        desc: "By accessing and using MMA Timer, you confirm that you have read, understood and accepted these terms. If you do not agree with any part of these terms, you must not use the application.",
      },
      license: {
        title: "License of Use",
        desc: "We grant you a limited, non-exclusive, non-transferable and revocable license to use MMA Timer on your personal mobile device. This license does not grant you ownership rights over the application or its content.",
      },
      restrictions: {
        title: "Usage Restrictions",
        desc: "By using MMA Timer, you agree not to:",
        items: [
          "Modify, decompile, disassemble or reverse-engineer the application",
          "Distribute, sublicense or transfer the application to third parties",
          "Use the application for illegal or unauthorized purposes",
          "Attempt to access unauthorized systems or networks through the application",
          "Remove or alter copyright notices or trademarks",
        ],
      },
      purchases: {
        title: "Purchases and Subscriptions",
        desc: "MMA Timer offers premium features available through a one-time in-app purchase. Purchases are processed through the corresponding app store (Google Play Store or Apple App Store) and are subject to their refund policies. The free plan includes all main application features without time limitations.",
      },
      liability: {
        title: "Limitation of Liability",
        desc: 'MMA Timer is provided "as is" and "as available". We do not guarantee that the application will be uninterrupted, error-free or that it will meet your specific requirements. We are not responsible for injuries, damages or losses that may result from using the application during training or physical activities. Always consult a professional before starting any training program.',
      },
      changes: {
        title: "Changes to Terms",
        desc: "We reserve the right to modify these terms at any time. Changes will be posted on this page and, if significant, we will notify you through the application. Continued use of MMA Timer after the publication of changes constitutes your acceptance of the new terms.",
      },
      contact: {
        title: "Contact",
        desc: "If you have questions about these terms and conditions, contact us:",
      },
    },
  },
};

